'use client'

import type { ImageData, VideoData } from '@/frontend-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { cx } from 'cva'
import Image from 'next/image'
import { useRef, useState, type FC } from 'react'
import { Video } from '../atoms/Video'

export type VideoBlockProps = {
	thumbnail?: ImageData
	thumbnailSizes?: string
	video: VideoData
}

export const VideoBlock: FC<VideoBlockProps> = ({ thumbnail, thumbnailSizes, video }) => {
	const videoRef = useRef<HTMLVideoElement>(null)
	const [isButtonHidden, setIsButtonHidden] = useState(false)

	return (
		<div className="w-full h-full">
			<div
				className={cx(
					'absolute inset-0 flex items-center justify-center z-5 transition-opacity duration-400 ease-in-out',
					isButtonHidden ? 'opacity-0 pointer-events-none' : 'opacity-100 pointer-events-auto',
				)}
			>
				<button
					className="group cursor-pointer w-full h-full flex items-center justify-center relative z-10"
					aria-label="Play video"
					onClick={() => {
						setIsButtonHidden(true)
						setTimeout(() => {
							videoRef.current?.play()
						}, 300)
					}}
				>
					<div
						className="flex h-14.5 w-14.5 items-center justify-center rounded-full bg-blue text-white group-hover:bg-blue-shade-40 group-hover:text-white group-active:bg-blue-shade-70 group-active:text-white tablet-l:h-20 tablet-l:w-20"
						aria-hidden="true"
					>
						<FontAwesomeIcon
							icon={['far', 'play']}
							className="text-[length:var(--size-icon-lg)] tablet-l:text-[length:var(--size-icon-xl)] !w-[1em] !h-auto"
						/>
					</div>
				</button>
				{thumbnail && (
					<div className="absolute inset-0 w-full h-full z-5">
						<Image
							src={thumbnail.src}
							alt={thumbnail.alt}
							fill
							className="object-cover"
							sizes={thumbnailSizes}
						/>
					</div>
				)}
			</div>
			<div className="w-full h-full z-0">
				<Video video={video} controls ref={videoRef} />
			</div>
		</div>
	)
}
